/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import Select from "react-select";
import config from "../../../config/config"
import { useSelector } from 'react-redux';
import { usePopupManager } from "../../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../../constants";
import axios from "axios";

import DashboardSection from '../../DashboardContainer/DashboardSection';
import TrademarkBarChart from '../../TrademarkBarChart/TrademarkBarChart';
import LegalPieChart from '../../LegalPieChart/LegalPieChart';
import ComplaintDisputeChart from '../../ComplaintDisputeChart/ComplaintDisputeChart';
import ComplaintDisputeBarChart from '../../ComplaintDisputeChart/ComplaintBarChart';
import DomainTile from '../../DomainTile/DomainTile';
import styles from './MainDashboard.module.css';
import './MainDashboard.css';
import RecordToReportPieChart from '../RecordToReportPieChart/RecordToReportPieChart';
import RecordToReportBarChart from '../RecordToReportBarChart/RecordToReportBarChart';
import RecordToReportSingleBar from '../RecordToReportSingleBar/RecordToReportSingleBar';
import ReportsStatusBarChart from '../ReportsStatusBarChart/ReportsStatusBarChart';
import DetailedDomainTile from '../../../atomicComponents/DetailedDomainTile/DetailedDomainTile';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import TrendIndicator from '../RecordToReportTrendIndicator/RecordToReportTrendIndicator';
import JLRMiniStat from "./JLRMiniStat";
import epm from "../R2RIcons/epm.png";
import RecordBarChart from "../RecordToReportBarChart/RecordBarChart";

const WeekOptions = [
    { value: 'undefined', label: 'Select' },
    { value: 'All', label: '-All-' },
    ...Array.from({ length: 52 }, (_, i) => ({
        value: `W${i + 1}`,
        label: `Week ${i + 1}`
    }))
];

const { API_BASE_URL } = config;

const MainDashBoardJLR = () => {

    const token = useSelector((state) => state.auth.djangoAccessToken);
    const roles = useSelector((state) => state.auth.djangoRoles);
    const userInfo = useSelector((state) => state.auth.djangoUserInfo);

    const location = useLocation();
    const { showPopup } = usePopupManager();

    const initialFilters = location.state || {
    entityData: null,
    yearData: null,
    monthData: [],
    };

    const [hasApplied, setHasApplied] = useState(false);

    const [filters, setFilters] = useState(initialFilters);

    const [showDashboard, setShowDashboard] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [entityOptions, setEntityOptions] = useState([]);
    const [yearOptions, setYearOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);

    const [entity, setEntity] = useState(null);
    const [year, setYear] = useState(null);
    const [month, setMonth] = useState([]);

    const [accuracyData, setAccuracyData] = useState([]);
    const [accuracyLabels, setAccuracyLabels] = useState([])
    const [epmValue, setEpmValue] = useState(0);
    const [timelinessData, setTimelinessData] = useState([]);
    const [timelinessLabels, setTimelinessLabels] = useState([]);
    
    const [changeText, setChangeText] = useState("");
    const [isIncrease, setIsIncrease] = useState(false);
    const [week, setWeek] = useState(WeekOptions[0]);

    const history = useHistory()

    const customStyles = {
        control: (provided) => ({
        ...provided,
        minHeight: '20px',
        flexWrap: 'wrap',
        }),
        valueContainer: (provided) => ({
        ...provided,
        maxHeight: '50px',
        overflowY: 'auto',
        }),
        menu: (provided) => ({
        ...provided,
        zIndex: 9999,
        overflow: 'visible',
        }),
        menuList: (provided) => ({
        ...provided,
        maxHeight: '200px',
        overflowY: 'auto',
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        }),
        option: (provided) => ({
        ...provided,
        padding: '8px 12px',
        }),
    };

    const handleEntityChange = (selected) => {
        setEntity(selected);
        setFilters(prev => ({ ...prev, entityData: selected }));
    };

    const handleYearChange = (selected) => {
        setYear(selected);
        setFilters(prev => ({ ...prev, yearData: selected }));
    };

    const handleMonthChange = (selected) => {
        const updatedMonths = selected || [];
        setMonth(updatedMonths);
        setFilters(prev => ({ ...prev, monthData: updatedMonths }));
    };

    const handleWeekChange = (selected) => {
        setWeek(selected);
        setFilters(prev => ({ ...prev, weekData: selected })); 
    };

    const handleApply = () => {

        const entityFilterData = entity?.value || "";
        const yearFilterData = year?.value || "";
        const monthFilterData = month?.map((m) => m?.value) || [];
    
        if (entityFilterData === ''){
            showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "Please select entity.",
            });
            return;
        }

        if (yearFilterData === '') {
            showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "Please select year.",
            });
            return;
        }
            
        setIsLoading(true);

        const val = entity?.value?.toUpperCase();

        if (val?.includes("AGRATAS")) {
        history.push("/Record-To-Report/Agratas",{yearData: [year], monthData:month});
        return;
        }

        if (!val?.includes("JLR")) {
        history.push("/Record-To-Report", filters);
        return;
        }

        const fetchJLRAccuracyTask = async () => {
            try {
                const response = await axios.post(`${API_BASE_URL}/api/JLR-accuracytask`, 
                { 
                    selectedEntity: entityFilterData,
                    selectedYear: yearFilterData,
                    selectedMonth: monthFilterData,
                },
                {headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                }},
                )
                .then((response) => {
                const result = response.data;
                const accuracyTasks = result.accuracyTask || [];

                if (accuracyTasks.length > 0) {
                    const row = accuracyTasks[0];

                    const chartData = [
                    {
                        label: [""],
                        data: [row.Journal,row.Reconciliations],
                        backgroundColor: ["#2196F3","#00BCD4"],
                    }
                    // {
                    //     label: "Non Journal",
                    //     data: [row.Non_Journal],
                    //     backgroundColor: "#f48200ff",
                    // },
                    // {
                    //     label: "Reconciliations",
                    //     data: [row.Reconciliations],
                    //     backgroundColor: "#f4a300",
                    // },
                ];
                setAccuracyLabels(["Journal","Reconciliations"])
                setAccuracyData(chartData);
                } else {
                    setAccuracyData([]);
                }
                })
            } catch (error) {
                console.error('Error fetching Accuracy of Tasks options:', error);
            }
        };


        const fetchJLREpmValue = async () => {
            let allPreviousMonth=[]
            monthFilterData.forEach((item)=>{
                if(item-1 !==0)allPreviousMonth.push(item-1)
                 })
                try {
                    const response = await axios.post(`${API_BASE_URL}/api/JLR-epm`, 
                    { 
                        selectedEntity: entityFilterData,
                        selectedYear: yearFilterData,
                        selectedMonth: monthFilterData,
                        previousMonth:allPreviousMonth,
                    },
                    {headers: {
                        // Authorization: `Bearer ${token}`,
                        Authorization: 'Basic YWRtaW4xOjEyMw==',
                    }},
                    )
                    .then((response) => {
                    const result = response.data;

                    const currentValue = result.current_month_value || 0;
                    const previousValue = result.previous_month_value || 0;

                    setEpmValue(currentValue);

                    const change = currentValue - previousValue;

                    if (change === 0) {
                    setChangeText("No Change MoM");
                    setIsIncrease(false);
                    } else if (change > 0) {
                    setChangeText(`${change} Increase MoM`);
                    setIsIncrease(true);
                    } else {
                    setChangeText(`${Math.abs(change)} Decrease MoM`);
                    setIsIncrease(false);
                    }
                    })
                } catch (error) {
                    console.error('Error fetching JLR No. of EPM options:', error);
             }
        };

        const fetchJLRTimelinessTask = async () => {
            try {
                const response = await axios.post(`${API_BASE_URL}/api/JLR-timelinesstask`, 
                { 
                    selectedEntity: entityFilterData,
                    selectedYear: yearFilterData,
                    selectedMonth: monthFilterData,
                },
                {headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                }},
                )
                .then((response) => {
                const result = response.data;
                const timelinessTasks = result.timelinessTask || [];

                if (timelinessTasks.length > 0) {
                    const row = timelinessTasks[0];

                    const chartData = [
                    {
                        label: [""],
                        data: [row.Journal, row.Non_Journal, row.Reconciliations],
                        backgroundColor: ["#2196F3","#FFC107","#00BCD4"],
                    }
                    // {
                    //     label: "Non Journal",
                    //     data: [row.Non_Journal],
                    //     backgroundColor: "#f48200ff",
                    // },
                    // {
                    //     label: "Reconciliations",
                    //     data: [row.Reconciliations],
                    //     backgroundColor: "#f4a300",
                    // },
                ];
                setTimelinessLabels(["Journal","Non Journal", "Reconciliations"]);
                setTimelinessData(chartData);
                } else {
                    setTimelinessData([]);
                }
                })
            } catch (error) {
                console.error('Error fetching Timeliness of Tasks options:', error);
            }
        };

        Promise.all([fetchJLRAccuracyTask(),fetchJLREpmValue(),fetchJLRTimelinessTask()]).then(() => {
        setShowDashboard(true);
        setIsLoading(false);
        });
    };

    const handleReset = () => {
        setEntity(null);
        setYear(null);
        setMonth([]);
        setWeek(WeekOptions[0]);
        setFilters({
        entityData: null,
        yearData: null,
        monthData: [],
        weekData: null,
        });
        setShowDashboard(false);
    };

    const fetchEntityOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/R2R-entity`, {
            headers: { 
                Authorization: "Basic YWRtaW4xOjEyMw==" 
                },
            });

            const allEntities = response.data?.[0]?.all || [];
            const jlrEntities = response.data?.[0]?.jlr || [];

            const entities = Array.isArray(roles?.entity) ? roles.entity : [roles?.entity];
            const userEntities = (entities.filter(Boolean)).map((e) => e.toUpperCase());

            let entityOptionsJLR = [];

            if (userEntities.includes("JLR") && userEntities.length > 1) {
            entityOptionsJLR = [...new Set([...jlrEntities, ...allEntities])];
            } else if (userEntities.includes("JLR")) {
            entityOptionsJLR = jlrEntities;
            } else {
            entityOptionsJLR = allEntities;
            }

            setEntityOptions(entityOptionsJLR);
        } catch (error) {
            console.error("Error fetching R2R-entity options:", error);
        }
    };

    const fetchYearOptions = async () => {
        try {
        const response = await axios.get(`${API_BASE_URL}/api/R2R-year`, {
            headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
        })
        .then((response) => {
            setYearOptions(response.data);
        })
        } catch (error) {
        console.error('Error fetching R2R-year options:', error);
        }
    };

    const fetchMonthOptions = async () => {
        try {
        const response = await axios.get(`${API_BASE_URL}/api/R2R-month`, {
            headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
        })
        .then((response) => {
            setMonthOptions(response.data);
        })
        } catch (error) {
        console.error('Error fetching R2R-month options:', error);
        }
    };

    useEffect(() => {
        fetchEntityOptions();
        fetchYearOptions();
        fetchMonthOptions();
    }, []);

    useEffect(() => {
    if (entityOptions.length && yearOptions.length && monthOptions.length) {

      if (filters.entityData?.value) {
        const ent = entityOptions.find(opt => opt.value === filters.entityData.value);
        if (ent) setEntity(ent);
      }
  
      if (filters.yearData?.value) {
        const yr = yearOptions.find(opt => opt.value === filters.yearData.value);
        if (yr) setYear(yr);
      }

      if (filters.monthData && filters.monthData.length > 0) {
        const mon = monthOptions.filter(opt =>
          filters.monthData.some(m => m.value === opt.value)
        );
        if (mon.length > 0) setMonth(mon);
      }

      if (filters.entityData?.value) {
        setTimeout(() => {
          setHasApplied(true);
        }, 1000);
      }
    }
  }, [entityOptions, yearOptions, monthOptions]);

  useEffect(() => {
    if (hasApplied === true ) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);

    return (
        <>
        <div className="row" >
          <div className="col-md-12">
            <DomainTile title='Record-To-Report JLR' showBackButton={false}
              mainPagePath = "/Record-To-Report"/>
          </div>
        </div>

            {/* Select Bar */}
            <div className={styles.filter_panel_container}>
                <div className={styles.filter_panel_row}>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Entity<span style={{ color: 'red' }}>*</span></label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={entity}
                                onChange={handleEntityChange}
                                options={entityOptions}
                                isSearchable={true}
                                // isMulti={true}
                                // closeMenuOnSelect={false}
                                // styles={customStyles}
                            />
                        </div>
                    </div>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Year<span style={{ color: 'red' }}>*</span></label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={year}
                                onChange={handleYearChange}
                                options={yearOptions}
                                isSearchable={true}
                                // isMulti={true}
                                // closeMenuOnSelect={false}
                                // styles={customStyles}
                            />
                        </div>
                    </div>

                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Month</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={month}
                                onChange={handleMonthChange}
                                options={monthOptions}
                                isSearchable={true}
                                isMulti={true}
                                closeMenuOnSelect={false}
                                styles={customStyles}
                            />
                        </div>
                    </div>

                    {/* <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Week</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={week}
                                onChange={setWeek}
                                options={WeekOptions}
                                isSearchable={true}
                                isMulti={true}
                                closeMenuOnSelect={false}
                                styles={customStyles}
                            />
                        </div>
                    </div> */}

                    <div className="filter-panel-col action-buttons">
                        <button onClick={handleApply} className="btn apply-btn">
                            Apply
                        </button>
                        <button onClick={handleReset} className="btn reset-btn">
                            Reset
                        </button>
                    </div>
                </div>
            </div>
            {isLoading && (
                <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    zIndex: 9999,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
                >
                <div className="text-center">
                    <div className="spinner-border text-primary mb-3" role="status"></div>
                    <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>
                </div>
                </div>
            )}
            {showDashboard && (
            <>
            {/* Titles */}
            <div className="row">
                <div className="col-md-12 col-lg-12 mb-1">
                    <DetailedDomainTile title='Accuracy' showButton={true} path='/Record-To-Report/JLR/Accuracy' detailState={filters}/>
                </div>
            </div>

            {/* First Row */}
            <div className="row mb-3">
                <div className='col-lg-9'>

                    <DashboardSection title="Accuracy of Tasks" disableDetailView={true} detailPath="" infoIcondata={"Manual CSV DATA"}>
                        <RecordBarChart labels={accuracyLabels} datasets={accuracyData} showLegend={false} height={200} hoverLabel={true}/>
                    </DashboardSection>

                </div>
                <div className='col-lg-3'>
                    <JLRMiniStat
                        title="Number of EPM Support Adjustments"
                        value={`${epmValue} entries`}
                        changeText={changeText}
                        isIncrease={isIncrease}
                        showArrow={true}
                        icon={epm}
                    />
                </div>
            </div>

            {/* Second Row */}

            <div className='row'>
                <div className="col-md-12 col-lg-12 mb-1">
                    <DetailedDomainTile title='Timeliness' showButton={true} path='/Record-To-Report/JLR/TimeLiness' detailState={filters}/>
                </div>
            </div>

            <DashboardSection
                className="mb-4"
                title="Timeliness of Tasks"
                disableDetailView={true} infoIcondata={"Manual CSV DATA"}>
                <div className='row'>
                    <div
                        className="col-12 d-flex justify-content-center align-items-center"
                        style={{ height: '100%', width: '100%' }}
                    >
                        <div style={{ width: '100%', height: '50%' }}>
                            <RecordBarChart labels={timelinessLabels} datasets={timelinessData} showLegend={false} height={250} hoverLabel={true}/>
                        </div>
                    </div>
                </div>
            </DashboardSection>
            </>
        )}
        </>
    );
};

export default MainDashBoardJLR;
